import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { DEPLOY_URL_PROVIDER, EnvironmentSettings, addIgnoreCaseUrlsStrategy, provideJwtAuthProvider } from '@polygon/core';
import { providePolygonShell } from '@polygon/shell';
import { customMainServices } from '../custom-code/custom.services';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { addElevationFwShellProviders } from "@elevation/shell";

const deploy = DEPLOY_URL_PROVIDER;

fetch(`${deploy.useValue}assets/environment.json`, {
    method: 'GET',
    headers: {
        'Cache-Control': 'no-cache'
    }
})
    .then((response) => response.json())
    .then((config: EnvironmentSettings) => {
        if (config.production) {
            enableProdMode();
        }

        bootstrapApplication(AppComponent, {
            providers: [
                provideZoneChangeDetection({ eventCoalescing: true }),
                provideAnimations(),
                provideHttpClient(withInterceptorsFromDi()),
                provideRouter(appRoutes, withComponentInputBinding()),
                provideServiceWorker(`${deploy.useValue}ngsw-worker.js`, {
                    enabled: !isDevMode(),
                    registrationStrategy: 'registerWhenStable:30000'
                }),
                providePolygonShell(),
                DEPLOY_URL_PROVIDER,
                {
                    provide: EnvironmentSettings,
                    useValue: config
                },
                ...customMainServices,
                addIgnoreCaseUrlsStrategy,
                addElevationFwShellProviders,
                provideJwtAuthProvider()
            ]
        }).catch((err) => console.error(err));
    });
